// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const resetSearchParams = () => ({
    type: actions.RESET_DEALER_SEARCH_PARAMS
});




// WEBPACK FOOTER //
// ./src/product/dealer-search/action-creators/reset-search-params.js